import { render, staticRenderFns } from "./OnboardingWorkersListCalendarSync.vue?vue&type=template&id=38efaa3b"
import script from "./OnboardingWorkersListCalendarSync.vue?vue&type=script&lang=ts"
export * from "./OnboardingWorkersListCalendarSync.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingWorkersListCalendarSync.vue?vue&type=style&index=0&id=38efaa3b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports